import {designSystemToken} from '@lightricks/react-design-system';

export function brandLinkSx() {
  return {
    font: 'inherit',
    color: designSystemToken('semantic.fg.brand'),
  };
}

export function brandLinkButtonSx() {
  return {
    ...brandLinkSx(),
    'padding': 0,
    'border': 0,
    'background': 'none',
    'cursor': 'pointer',
    '&:hover': {textDecoration: 'underline'},
  };
}
